/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Plan_Changed_No_ChargeInputs */

const en_plan_changed_no_charge = /** @type {(inputs: Plan_Changed_No_ChargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switched to ${i?.plan}. Nothing charged today.`)
};

const es_plan_changed_no_charge = /** @type {(inputs: Plan_Changed_No_ChargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambiaste a ${i?.plan}. No se cobró nada hoy.`)
};

/**
* | output |
* | --- |
* | "Switched to {plan}. Nothing charged today." |
*
* @param {Plan_Changed_No_ChargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_changed_no_charge = /** @type {((inputs: Plan_Changed_No_ChargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Changed_No_ChargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_changed_no_charge(inputs)
	return en_plan_changed_no_charge(inputs)
});